/// <reference types='@types/youtube' />
import type { SocialPlayerSharedData } from '../../../SocialPlayerShared/SocialPlayersShared.types';

export const getIframeUrl = (
  videoId: string,
  options: Pick<
    SocialPlayerSharedData,
    | 'mute'
    | 'autoPlay'
    | 'loop'
    | 'enabledCaptions'
    | 'enabledControls'
    | 'startTime'
    | 'endTime'
  >,
): string => {
  const {
    mute,
    autoPlay,
    loop,
    enabledCaptions,
    enabledControls,
    startTime,
    endTime,
  } = options;

  const youtubeUrl = new URL(`https://www.youtube.com/embed/${videoId}`);
  const paramClone: YT.PlayerVars = {
    enablejsapi: 0,
    // TODO: Add origin?
    controls: enabledControls ? 1 : 0,
    mute: autoPlay || mute ? 1 : 0,
    loop: loop ? 1 : 0,
    autoplay: autoPlay ? 1 : 0,
    cc_load_policy: enabledCaptions ? 1 : 0,
    start: startTime,
    end: endTime,
    playlist: videoId,
  };
  for (const [key, value] of Object.entries(paramClone)) {
    if (value === undefined || value === null) {
      continue;
    }
    youtubeUrl.searchParams.append(key, value.toString());
  }
  return youtubeUrl.toString();
};
